/************************************************************************************

* CUSTOMIZE FUNCTION: Customize add-on price

*************************************************************************************/

document.addEventListener('DOMContentLoaded', () => {
  const productBlocksEl = document.querySelector('.product-single__meta')
  if (!productBlocksEl) return;

  function l_infiniteOptionUpdatePrices() {
    // Helper to query element and optionally throw for missing element
    const getEl = (selector) => document.querySelector(selector);

    const infiniteoptionsPriceContainerEl = getEl('.infiniteoptions-price');

    if (!infiniteoptionsPriceContainerEl) return;

    const infiniteoptionsPriceEl = infiniteoptionsPriceContainerEl.querySelector('.price-item.price-item--regular');
    const currentVariantPriceEl = getEl('.product-block.product-block--price');

    if (!infiniteoptionsPriceEl || !currentVariantPriceEl) return;

    infiniteoptionsPriceContainerEl.classList.add('l-hidden')

    // Parse prices
    const infiniteoptionsPrice = l_parseMoneyToCents(infiniteoptionsPriceEl.textContent.trim());
    const currentVariantPrice = l_parseMoneyToCents(currentVariantPriceEl.textContent);

    // Compute add-on price
    const addOnPrice = infiniteoptionsPrice - currentVariantPrice;

    // Query all price elements together
    const priceEls = {
      plus: document.getElementById('productPricePlus'),
      addOn: document.getElementById('productPriceAddOn'),
      equal: document.getElementById('productPriceEqual'),
      total: document.getElementById('productPriceTotal')
    };

    // Remove hidden class and update content for available elements
    Object.values(priceEls).forEach(el => {
      if (el) el.classList.remove('l-hidden');
    });

    if (priceEls.addOn) {
      priceEls.addOn.textContent = l_formatMoney(addOnPrice);
    }
    if (priceEls.total) {
      priceEls.total.textContent = infiniteoptionsPriceEl.textContent.trim();
    }
  }

  productBlocksEl.addEventListener('change', () => {
    const delayTimes = [1500, 2000];

    delayTimes.forEach(delay => {
      l_debounce(() => {
        l_infiniteOptionUpdatePrices();
      }, delay)();
    });
  });

  document.addEventListener('variant:change', function (event) {
    const delayTimes = [1500, 2000];

    delayTimes.forEach(delay => {
      l_debounce(() => {
        l_infiniteOptionUpdatePrices();
      }, delay)();
    });
  });

})

